import { Box } from "@mui/material";
import React, { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const PagePaperPreambleContainer = () => {
  return <Box id="page-paper-preamble" mb={1} sx={{ "&:empty": { display: "none" } }}></Box>;
};

export const PagePaperPreamble = ({ children }: { children: ReactNode }) => {
  const [rendered, setRendered] = useState(false);
  useEffect(() => {
    setRendered(true);
  }, []);
  if (!rendered) return null;
  return createPortal(children, document.getElementById("page-paper-preamble") as HTMLElement);
};
